import { render, staticRenderFns } from "./StockIcon.vue?vue&type=template&id=4f338492&scoped=true&"
import script from "./StockIcon.vue?vue&type=script&lang=ts&"
export * from "./StockIcon.vue?vue&type=script&lang=ts&"
import style0 from "./StockIcon.vue?vue&type=style&index=0&id=4f338492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f338492",
  null
  
)

export default component.exports